@if (warranties$ | async; as warranties) { @if (warranties.length) {
<div class="product-warranty">
  @switch (viewType()) {
  <!-- default display option is radio-buttons -->
  @default {
  <div class="product-warranty-title">{{ 'product.warranty.heading.text' | translate }}:</div>
  <div class="product-warranty-list" data-testing-id="product-warranties">
    @for (warranty of warranties; track warranty) {
    <div class="mb-2">
      <input
        type="radio"
        [id]="'warranty_' + uuid + warranty.id"
        [name]="'warranty_' + uuid"
        [value]="warranty.id"
        class="form-check-input"
        [checked]="selectedWarrantySku() ? selectedWarrantySku() === warranty.id : !warranty.id"
        (change)="updateWarranty(warranty.id)"
      />
      <label class="form-check-label" [for]="'warranty_' + uuid + warranty.id">
        {{ warranty.name }}@if (warranty.id) {
        <span
          ><span class="product-warranty-price"> {{ warranty.price | ishPrice }}</span>
          <ish-product-warranty-details [warranty]="warranty"
        /></span>
        }
      </label>
    </div>
    }
  </div>
  }
  <!-- viewType select-box -->
  @case ('select') {
  <select
    class="form-control d-inline-block w-auto"
    [attr.aria-label]="'product.warranty.heading.text' | translate"
    (change)="updateWarranty($event.target)"
    data-testing-id="product-warranties"
  >
    <!-- generate all available warranties in a select box -->
    @for (warranty of warranties$ | async; track warranty) {
    <option
      [value]="warranty.id"
      [selected]="selectedWarrantySku() ? selectedWarrantySku() === warranty.id : warranty.id === ''"
    >
      {{ warranty.name }}@if (warranty.id) {
      <span> - {{ warranty.price | ishPrice }}</span>
      }
    </option>
    }
  </select>
  @if (selectedWarrantySku()) {
  <ish-product-warranty-details [warranty]="getSelectedWarranty$(selectedWarrantySku()) | async" />
  } } @case ('display') { @if (getSelectedWarranty$(selectedWarrantySku()) | async; as selectedWarranty) {
  {{ selectedWarranty.name }}
  <ish-product-warranty-details [warranty]="selectedWarranty" />
  } } }
</div>
} }
